import { Skeleton } from '@/components/ui/skeleton'

export function ChatMessagesLoading() {
  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-col items-start gap-1 self-start'>
        <Skeleton className='h-16 w-64 rounded-[16px_16px_16px_0]' />
        <Skeleton className='h-3 w-12' />
      </div>
      <div className='flex flex-col items-end gap-1 self-end'>
        <Skeleton className='h-20 w-72 rounded-[16px_16px_0_16px]' />
        <Skeleton className='h-3 w-12' />
      </div>
      <div className='flex flex-col items-start gap-1 self-start'>
        <Skeleton className='h-12 w-56 rounded-[16px_16px_16px_0]' />
        <Skeleton className='h-3 w-12' />
      </div>
      <div className='flex flex-col items-end gap-1 self-end'>
        <Skeleton className='h-24 w-80 rounded-[16px_16px_0_16px]' />
        <Skeleton className='h-3 w-12' />
      </div>
      <div className='flex flex-col items-start gap-1 self-start'>
        <Skeleton className='h-14 w-60 rounded-[16px_16px_16px_0]' />
        <Skeleton className='h-3 w-12' />
      </div>
      <div className='flex flex-col items-end gap-1 self-end'>
        <Skeleton className='h-16 w-64 rounded-[16px_16px_0_16px]' />
        <Skeleton className='h-3 w-12' />
      </div>
      <div className='flex flex-col items-start gap-1 self-start'>
        <Skeleton className='h-20 w-72 rounded-[16px_16px_16px_0]' />
        <Skeleton className='h-3 w-12' />
      </div>
      <div className='flex flex-col items-end gap-1 self-end'>
        <Skeleton className='h-12 w-56 rounded-[16px_16px_0_16px]' />
        <Skeleton className='h-3 w-12' />
      </div>
    </div>
  )
}
